import React, { useEffect } from 'react';
import './App.css';
import Navbar from './components/layout/Navbar';
import Dashboard from './components/layout/Dashboard';
import useThemeStore from './store/theme.store';

function App() {
  const { theme, setTheme } = useThemeStore();
  useEffect(() => {
    const documentElement = document.documentElement;

    if (theme === "none") {
      // FIXME: Enable when there's full dark theme support
      // if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      //   documentElement.classList.add("dark-default", "dark");
      //   documentElement.classList.remove("golain");
      //   setTheme("dark-default");
      // } else {
      documentElement.classList.add("golain");
      documentElement.classList.remove("dark-default", "dark");
      setTheme("golain");
      // }
    } else if (theme === "dark-default") {
      documentElement.classList.add("dark-default", "dark");
      documentElement.classList.remove("golain");
    } else if (theme === "golain") {
      documentElement.classList.remove("dark-default", "dark");
      documentElement.classList.add("golain");
    }
  }, [setTheme, theme]);

  return (
    <div className="App min-h-screen bg-background-layer1">
      <Navbar />
      <main>
        <Dashboard />
      </main>
    </div>
  );
}

export default App;